import * as React from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router'
import { AnyAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'
import NumericTextboxComponent from 'react-numeric-textbox'
import {
  changeKoppelingActionCreator,
  clearDataActionCreator,
  getKoppelingenCreator,
  IChangeKoppelingAction,
  IClearDataResponseAction,
  IGetCombinatieDataResponseAction,
  IUpdateKoppelingenResponseAction,
  updateKoppelingenCreator,
} from '../../redux/store/actions/aarCombinatiesAction'
import { IApplicationState } from 'redux/store/store'
import { Loader } from 'shared/components/Loader'
import { VestigingEnum } from 'shared/models/Enum'
import { IAarCombinatieSelectie } from 'shared/models/IAarCombinatieSelectie'
import { IUpdateKoppelingRequest } from 'shared/models/PostRequestModel'
import { IExtendedKoppeling } from 'shared/models/IAfleverafspraakLocatieKoppeling'
import { ILocatieGlnModel } from 'shared/models/ILocatieGlnModel'
import {
  formatDate,
  comparableDate,
} from 'shared/service/helpers/DateUtilities'

interface IProps {
  requestData: (
    selectie: IAarCombinatieSelectie
  ) => Promise<IGetCombinatieDataResponseAction>
  clearData: (message: string) => Promise<IClearDataResponseAction>
  updateKoppelingen: (
    request: IUpdateKoppelingRequest[],
    selection: IAarCombinatieSelectie
  ) => Promise<IUpdateKoppelingenResponseAction>
  changeKoppeling: (
    koppeling: IExtendedKoppeling,
    value: string,
    canCombine: boolean
  ) => Promise<IChangeKoppelingAction>
  locaties: ILocatieGlnModel[]
  schermloading: boolean
  foutmelding: string
  globalVestiging: VestigingEnum
}

const AarCombinatiesLijst: React.FunctionComponent<IProps> = ({
  requestData,
  clearData,
  updateKoppelingen,
  changeKoppeling,
  locaties,
  schermloading,
  foutmelding,
  globalVestiging,
}) => {
  const [agreementReference, setAgreementReference] = useState('')
  const [customerNumber, setCostumerNumber] = useState<number>()
  const [locationgGln, setlocationGln] = useState<number>()

  const zoekKoppelingenIfEnter = (e: string) => {
    if (e === 'Enter') {
      zoekKoppelingen()
    }
  }

  const zoekKoppelingen = () => {
    if (canSearch()) {
      requestData({
        vestiging: globalVestiging,
        klantnummer: customerNumber,
        locatieGln: locationgGln,
        afspraakreferentie: agreementReference,
      })
    }
  }

  const canSearch = (): boolean => {
    return (
      !!globalVestiging &&
      (!!agreementReference || !!customerNumber || !!locationgGln)
    )
  }

  const re = /^[0-9\b]+$/

  const setKlantnummer = x => {
    if (re.test(x) || x === null) {
      setCostumerNumber(x)
      setAgreementReference('')
      setlocationGln(undefined)
    }
  }

  const setLocatie = x => {
    if (re.test(x) || x === null) {
      setlocationGln(x)
      setCostumerNumber(undefined)
      setAgreementReference('')
    }
  }

  const setAfleverafspraakReferentie = x => {
    setlocationGln(undefined)
    setCostumerNumber(undefined)
    setAgreementReference(x)
  }

  const getVestiging = (id: number): string => {
    return VestigingEnum[id]
  }

  const setCanCombine = (koppeling: IExtendedKoppeling, value: boolean) => {
    changeKoppeling(
      koppeling,
      value && !!koppeling.combinatie ? koppeling.combinatie : '',
      value
    )
  }

  const setCombination = (koppeling: IExtendedKoppeling, value: string) => {
    if (koppeling.nieuweWaardeMagCombineren) {
      changeKoppeling(koppeling, value, koppeling.nieuweWaardeMagCombineren)
    }
  }

  const hasChangedKoppelingen = (
    koppelingen: IExtendedKoppeling[]
  ): boolean => {
    return koppelingen.some(k => isChanged(k))
  }

  const isChanged = (koppeling: IExtendedKoppeling): boolean => {
    return (
      (koppeling.combinatie !== koppeling.nieuweWaardeCombinatie &&
        (!!koppeling.combinatie || !!koppeling.nieuweWaardeCombinatie)) ||
      koppeling.magCombineren !== koppeling.nieuweWaardeMagCombineren
    )
  }

  const opslaanKoppelingen = (locatie: ILocatieGlnModel) => {
    const changes = locatie.koppelingen
      .filter(k => isChanged(k))
      .map(k => {
        const request: IUpdateKoppelingRequest = {
            klantNummer: k.klantAfleverafspraak.klant.klantNummer,
            koppelingId: k.afleverafspraakLocatieKoppelingId,
            shipToLocationGlnId: k.shipToLocationGlnId,
            combinatie: k.nieuweWaardeCombinatie,
            routeToKlantId: k.routeToKlantId,
            routeToLocationGlnId: k.routeToLocationGlnId,
            orderTypes: k.orderTypes,
            dagen: k.dagen,
            koppelingType: k.koppelingType,
            toelichting: ''
        }
        return request
      })

    if (!!changes) {
      updateKoppelingen(changes, {
        vestiging: globalVestiging,
        klantnummer: customerNumber,
        locatieGln: locationgGln,
        afspraakreferentie: agreementReference,
      })
    }
  }

  const renderLocaties = (locaties: ILocatieGlnModel[]) => {
    return locaties.map(l => {
      return (
        <div key={l.locatieGlnCode}>
          <table className='table'>
            <thead>
              <tr className='tablesubheader'>
                <th colSpan={4}>Locatie</th>
              </tr>
            </thead>
            <tbody>
              <tr className='tablesubheader'>
                <td>Locatie Gln</td>
                <td>Locatie Naam</td>
                <td>Locatie Omschrijving</td>
                <td>Vestiging</td>
              </tr>
              <tr>
                <td>{l.locatieGlnCode}</td>
                <td>{l.locatieGlnNaam}</td>
                <td>{l.locatieGlnOmschrijving}</td>
                <td>{getVestiging(l.vestigingCode)}</td>
              </tr>
            </tbody>
          </table>
          {renderKoppelingen(l)}
        </div>
      )
    })
  }

  const renderKoppelingen = (locatie: ILocatieGlnModel) => {
    return (
      <table className='table ml-4'>
        <thead>
          <tr className='tablesubheader'>
            <th colSpan={7}>Gekoppelde afleverafspraken</th>
            <th colSpan={2}>Combineren?</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr className='tablesubheader'>
            <td>Afleverafspraakreferentie</td>
            <td>Afleverafspraaknaam</td>
            <td>Ingangsdatum</td>
            <td>Einddatum</td>
            <td>Klantnr.</td>
            <td>Naam</td>
            <td>EAN</td>
            <td>Nee</td>
            <td>Ja</td>
            <td>Code combinatie</td>
          </tr>
          {locatie.koppelingen
            .sort((a, b) =>
              a.klantAfleverafspraak.naam > b.klantAfleverafspraak.naam
                ? 1
                : a.klantAfleverafspraak.naam < b.klantAfleverafspraak.naam
                ? -1
                : comparableDate(formatDate(a.ingangsDatumtijd)) >
                  comparableDate(formatDate(b.ingangsDatumtijd))
                ? 1
                : -1
            )
            .map(k => (
              <tr key={k.afleverafspraakLocatieKoppelingId}>
                <td>{k.klantAfleverafspraak.afleverafspraakReferentie}</td>
                <td>{k.klantAfleverafspraak.naam}</td>
                <td>{formatDate(k.ingangsDatumtijd)}</td>
                <td>{formatDate(k.eindDatumtijd)}</td>
                <td>{k.klantAfleverafspraak.klant.klantNummer}</td>
                <td
                  className='mw-200 overflow-hidden'
                  title={k.klantAfleverafspraak.klant.klantNaam}
                >
                  {k.klantAfleverafspraak.klant.klantNaam}
                </td>
                <td>{k.klantAfleverafspraak.klant.klantEanCode}</td>
                <td>
                  <input
                    type='radio'
                    checked={!k.nieuweWaardeMagCombineren}
                    onChange={() => setCanCombine(k, false)}
                  />
                </td>
                <td>
                  <input
                    type='radio'
                    checked={k.nieuweWaardeMagCombineren}
                    onChange={() => setCanCombine(k, true)}
                  />
                </td>
                <td>
                  <input
                    type='text'
                    className='mw-170'
                    disabled={!k.nieuweWaardeMagCombineren}
                    maxLength={10}
                    value={k.nieuweWaardeCombinatie}
                    onChange={e => setCombination(k, e.target.value)}
                  />
                </td>
              </tr>
            ))}
          <tr>
            <td colSpan={10}>
              <div className='row no-gutters'>
                <div className='col'></div>
                <div className='col-auto'>
                  <button
                    className='btn btn-primary'
                    disabled={!hasChangedKoppelingen(locatie.koppelingen)}
                    onClick={() => opslaanKoppelingen(locatie)}
                  >
                    Opslaan
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  return (
    <div>
      {globalVestiging === undefined && <Redirect to='/home' />}
      <h2>Onderhouden combinaties van afleverafspraken</h2>

      <div>
        {schermloading && (
          <div>
            <Loader show={true} />
          </div>
        )}
        <table className='selectie'>
          <thead>
            <tr>
              <th className='selectie-label'>Klantnummer:</th>
              <th className='selectie-label'>Afspraakreferentie:</th>
              <th className='selectie-label'>Glncode Locatie:</th>
              <th className='selectie-label'>Vestiging:</th>
              <th className='selectie-label'></th>
            </tr>
          </thead>
          <tbody>
            <tr onKeyUp={e => zoekKoppelingenIfEnter(e.key)}>
              <td>
                <NumericTextboxComponent
                  min={0}
                  max={999999}
                  decimals={0}
                  format={'0'}
                  value={customerNumber}
                  onChange={e => setKlantnummer(e)}
                />
              </td>
              <td>
                <input
                  value={agreementReference}
                  onChange={e => setAfleverafspraakReferentie(e.target.value)}
                />
              </td>
              <td>
                <NumericTextboxComponent
                  min={0}
                  max={9999999999999}
                  decimals={0}
                  format={'0'}
                  value={locationgGln}
                  onChange={e => setLocatie(e)}
                />
              </td>
              <td>{VestigingEnum[globalVestiging]}</td>
              <td>
                <div className='row no-gutters'>
                  <div className='col'></div>
                  <div className='col-auto'>
                    <button
                      className='btn btn-primary'
                      disabled={!canSearch()}
                      onClick={zoekKoppelingen}
                    >
                      Zoek
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {!!foutmelding && (
        <div className='alert alert-danger maxedbox'>{foutmelding}</div>
      )}
      {!!locaties && <div>{renderLocaties(locaties)}</div>}
    </div>
  )
}

const mapStateToProps = (store: IApplicationState) => {
  return {
    schermloading: store.aarCombinatiesState.loading,
    locaties: store.aarCombinatiesState.locaties,
    globalVestiging: store.globalState.vestiging,
    foutmelding: store.aarCombinatiesState.foutmelding,
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    requestData: (selectie: IAarCombinatieSelectie) =>
      dispatch(getKoppelingenCreator(selectie)),
    clearData: (message: string) => dispatch(clearDataActionCreator(message)),
    updateKoppelingen: (
      request: IUpdateKoppelingRequest[],
      selection: IAarCombinatieSelectie
    ) => dispatch(updateKoppelingenCreator(request, selection)),
    changeKoppeling: (
      koppeling: IExtendedKoppeling,
      value: string,
      canCombine: boolean
    ) => dispatch(changeKoppelingActionCreator(koppeling, value, canCombine)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AarCombinatiesLijst)
